import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { GrowlerService } from '../../../shared/growler/growler.service';

export interface ConfirmWithSelectionDialogInput
{
    title: string;
    content: string;
    selectionLabel: string;
    selections?: {
        [key: string]: any;
        label: string;
    }[];
    btnContent: string;
    secondaryBtnContent?: string;
    selectionRequired: boolean;
    selectionRequiredSecondary?: boolean;
    useOutlineAppearance?: boolean;
    selectionWarning?: (selection: { id: number; label: string; }) => string;
}

export interface ConfirmWithSelectionDialogResult
{
    success: boolean;
    secondaryBtnClicked: boolean;
    selection: {
        [key: string]: any;
        label: string;
    };
}


@Component({
    selector: 'app-confirm-with-selection-dialog',
    templateUrl: './confirm-with-selection-dialog.component.html',
    standalone: true,
    imports: [
        SharedModule,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})

export class ConfirmWithSelectionDialogComponent implements OnChanges
{
    @Input() open = false;
    @Input() data: ConfirmWithSelectionDialogInput;
    @Input() size: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'full' = 'sm';
    @Output() readonly closed = new EventEmitter<ConfirmWithSelectionDialogResult | null>();

    form: UntypedFormGroup = null;
    selectedIndex: number = null;

    constructor(
            private _formBuilder: UntypedFormBuilder,
            private _growler: GrowlerService,
    ) {
    }

    get selectionItems(): { value: number; label: string }[] {
        return (this.data?.selections ?? []).map((selection, index) => ({value: index, label: selection.label}));
    }

    ngOnChanges(changes: SimpleChanges): void {
        if ((changes.open || changes.data) && this.open && this.data) {
            this.reset();
        }
    }

    onSelectionChange(index: number): void {
        this.selectedIndex = index;
        this.form.get('selection').setValue(this.data.selections?.[index] ?? null);
    }

    private reset(): void {
        this.selectedIndex = null;
        this.form = this._formBuilder.group({
            selection: [
                null,
                this.data.selectionRequired ? [Validators.required] : [],
            ],
        });
    }

    closeAndConfirm(secondary: boolean = false) {
        if (secondary && this.data.hasOwnProperty('selectionRequiredSecondary') && !this.data.selectionRequiredSecondary) {
            this.closed.emit(<ConfirmWithSelectionDialogResult>{
                success: true,
                secondaryBtnClicked: true,
            });
            return;
        }
        if (this.form.invalid) {
            this._growler.error('Missing Reason', 'The reason is a required field.');
            return;
        }
        this.closed.emit(<ConfirmWithSelectionDialogResult>{
            success: true,
            secondaryBtnClicked: secondary,
            selection: this.form.get('selection').value,
        });
    }

}
